module.exports = __webpack_public_path__ + "static/media/0029_IMG_L_ESPACE_DE_RESTAURATION.417bee0b.png";